/* =========================================================
   VP Flow — funnel state machine (v3)

   Rewritten to match the current liquid/css: only 3 steps exist
   (case color, refill, bundle picker) — there is no step-4 order
   summary or reservation form, no subscription toggle, no refill-none,
   and no kids/"add another adult" accordion in the markup anymore, so
   all of that has been removed rather than left as dead code.
   ========================================================= */

(function () {
  var HIDDEN_SECTIONS_SELECTOR = '#app > .mainContent > div .shopify-section';
  var KEEP_VISIBLE_CLASSES = [
    'vp-announcement-bar--section',
    'vp-header--section',
    'vp-flow--section',
    'vp-nutrition-facts--sidebar',
    'vp-flow-cart--section',
    'vp-nutrition-facts--sidebar-v2'
  ];

  // TripleWhale funnel tracking — mirrors the trackTriplePixel helper in
  // resources/assets/js_original/vivo-pebble.js (the older Pebble flow),
  // whitelisted/capped the same way so a payload never leaks unexpected
  // keys or object/array values into the pixel.
  function trackTriplePixel(eventName, payload) {
    if (typeof window.TriplePixel !== 'function') return;
    var cleanPayload = {};
    var keys = Object.keys(payload || {});
    for (var i = 0; i < keys.length && i < 10; i++) {
      var key = keys[i];
      var val = payload[key];
      if (typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean') {
        cleanPayload[key] = val;
      }
    }
    // console.log("TripleWhale Event: ", eventName);
    // console.log("TripleWhale Event payload: ", cleanPayload);
    window.TriplePixel('custom', eventName, cleanPayload);
  }

  // Step-view dedup is shared at page scope (not per flow instance) since
  // step 1 is tracked from the overlay-open handler (initToggle) while
  // steps 2/3 are tracked from showStep (initFlow) — both need to agree
  // on what's already been counted for this page view.
  var trackedFunnelSteps = {};
  function trackStepView(stepNum, label) {
    if (trackedFunnelSteps[stepNum]) return;
    trackedFunnelSteps[stepNum] = true;
    trackTriplePixel('PebbleV2StepViewed', { step: stepNum, label: label });
  }

  function playFlowVideo(video) {
    var playRequest = video.play();
    if (playRequest && typeof playRequest.catch === 'function') {
      playRequest.catch(function (err) {
        if (err.name !== 'AbortError') {
          console.warn('VP Flow: case video could not autoplay', err);
        }
      });
    }
  }

  /* ---------------------------------------------------------------------
   * Video loading.
   *
   * Every case video ships with preload="none" and its URL in data-src, so
   * nothing downloads on page load. The old code only moved data-src → src
   * inside renderVisual(), i.e. at the moment of the tap — so on Android
   * the tap paid for the request, buffering a 1080p file AND MediaCodec
   * decoder start-up before the first frame. Desktop/iOS hide that cost;
   * mid-range Android doesn't.
   *
   * hydrateFlowVideo() is now the single place a video gets its src, and
   * it's called AHEAD of need (idle after load, finger-down on the CTA /
   * colour buttons, step-2 video while the user is still on step 1).
   * preload 'metadata' = cheap header fetch; 'auto' = buffer for playback.
   * Calling it again with 'auto' upgrades an earlier 'metadata' hydrate
   * without restarting the download.
   * ------------------------------------------------------------------- */

  var VP_MOBILE_MQ = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;

  function hydrateFlowVideo(video, preload) {
    if (!video) return;
    preload = preload || 'auto';

    var source = video.querySelector('source[data-src]');
    if (source) {
      var mobileSrc = source.getAttribute('data-src-mobile');
      var desktopSrc = source.getAttribute('data-src');
      var src = (VP_MOBILE_MQ && VP_MOBILE_MQ.matches && mobileSrc) || desktopSrc;
      source.setAttribute('src', src);
      if (src !== desktopSrc) {
        // The mobile URL is derived in Liquid; if that rendition is missing, reload with the desktop file.
        source.addEventListener('error', function () {
          source.setAttribute('src', desktopSrc);
          video.load();
          if (video.classList.contains('vp-flow__visual-video--active')) playFlowVideo(video);
        }, { once: true });
      }
      source.removeAttribute('data-src');
      video.preload = preload;
      video.load();
      return;
    }

    if (preload === 'auto' && video.preload !== 'auto') {
      video.preload = 'auto';
    }
  }

  function saveDataEnabled() {
    var conn = navigator.connection;
    return Boolean(conn && conn.saveData);
  }

  function warmFlows() {
    document.querySelectorAll('[data-vp-flow]').forEach(function (flow) {
      flow.dispatchEvent(new Event('vp-flow:warm'));
    });
  }

  function showFlowOverlay() {
    document.querySelectorAll(HIDDEN_SECTIONS_SELECTOR).forEach(function (section) {
      if (KEEP_VISIBLE_CLASSES.some(function (cls) { return section.classList.contains(cls); })) return;
      section.hidden = true;
    });

    const footerInterval = setInterval(() => {
      const footer = document.querySelector('#app .mainContent > div > footer');

      if (footer) {
        footer.hidden = true;
        clearInterval(footerInterval);
      }
    }, 100);

    document.querySelectorAll('[data-vp-flow]').forEach(function (flow) {
      flow.hidden = false;
      flow.dispatchEvent(new Event('vp-flow:open'));
    });

    document.querySelectorAll('[data-vp-flow-visual-video].vp-flow__visual-video--active').forEach(function (video) {
      if (video.paused) playFlowVideo(video);
    });
  }

  function hideFlowOverlay() {
    document.querySelectorAll(HIDDEN_SECTIONS_SELECTOR).forEach(function (section) {
      section.hidden = false;
    });
    
    if(document.querySelector('#app .mainContent > div > footer')) {
      document.querySelector('#app .mainContent > div > footer').hidden = false;
    }

    document.querySelectorAll('[data-vp-flow]').forEach(function (flow) {
      flow.hidden = true;
    });

    document.querySelectorAll('[data-vp-flow-visual-video]').forEach(function (video) {
      if (!video.paused) video.pause();
    });
  }

  function initFlow(root) {
    var dataNode = root.closest(".shopify-section").querySelector('[data-vp-flow-data]');
    var data = {};
    try {
      data = JSON.parse(dataNode.textContent);
    } catch (err) {
      data = {};
    }

    var defaultColor = root.getAttribute('data-vp-flow-default-color') || null;

    var state = {
      step: 1,
      color: defaultColor,
      skipDispenser: false,
      refill: null,
      adultRefill: null,
      bundle: null,
      frequency: '1month',
      // Explicit re-entrancy guard for the add-to-cart flow — separate
      // from the continue button's own `disabled` state so a double
      // submission is blocked even if something ever calls
      // addSelectionToCart() directly, bypassing the button's click
      // handler (which already checks `btn.disabled` too).
      isAddingToCart: false
    };

    var els = {
      // NOTE: scoped to `.vp-flow__step` specifically — the step-icons
      // blocks further down also carry `[data-vp-flow-step]` for their
      // own show/hide, and a plain `[data-vp-flow-step]` selector here
      // would mix the two lists together.
      steps: Array.prototype.slice.call(root.querySelectorAll('.vp-flow__step[data-vp-flow-step]')),
      stepIcons: Array.prototype.slice.call(root.querySelectorAll('.vp-flow__step-icons[data-vp-flow-step]')),
      freqBlock: root.querySelector('[data-vp-flow-freq-block]'),
      visualStates: Array.prototype.slice.call(root.querySelectorAll('[data-vp-flow-visual-state]')),
      visualVideos: Array.prototype.slice.call(root.querySelectorAll('[data-vp-flow-visual-video]')),
      skipDispenserBtn: root.querySelector('[data-vp-flow-skip-dispenser]'),
      skipDispenserCheck: root.querySelector('[data-vp-flow-skip-dispenser-check]'),
      backButton: root.querySelector('[data-vp-flow-back]'),
      continueButtons: Array.prototype.slice.call(root.querySelectorAll('[data-vp-flow-continue]')),
      dotsWrap: root.querySelector('[data-vp-flow-dots]'),
      stepsWrap: root.querySelector('[data-vp-flow-steps]')
    };

    var dots = els.dotsWrap ? Array.prototype.slice.call(els.dotsWrap.querySelectorAll('.vp-flow__dot')) : [];

    var currentVisualVideo = null;
    var currentVisualKey = null;
    var lastRequestedVisualKey = null;

    /* ---------------------------------------------------------------------
     * Visual column: case-variant video, selected by step and color
     * ------------------------------------------------------------------- */

    function showVisualState(name) {
      els.visualStates.forEach(function (el) {
        el.hidden = el.getAttribute('data-vp-flow-visual-state') !== name;
      });
    }

    function activateVisualVideo(video, visualKey, selectionChanged) {
      var shouldRestart = video && (selectionChanged || video !== currentVisualVideo || visualKey !== currentVisualKey);
      if (shouldRestart && video.readyState >= 1) {
        video.pause();
        video.currentTime = 0;
      }

      els.visualVideos.forEach(function (visualVideo) {
        var isActive = visualVideo === video;
        visualVideo.classList.toggle('vp-flow__visual-video--active', isActive);

        if (!isActive) {
          visualVideo.pause();
        } else if (!root.hidden) {
          playFlowVideo(visualVideo);
        } else {
          visualVideo.pause();
        }
      });

      currentVisualVideo = video;
      currentVisualKey = video ? visualKey : null;
    }

    els.visualVideos.forEach(function (video) {
      video.addEventListener('error', function () {
        var isSelectedColor = video.getAttribute('data-vp-flow-video-color') === state.color;
        var expectedType = state.step === 2 ? 'step2' : 'step13';
        if (isSelectedColor && video.getAttribute('data-vp-flow-visual-video') === expectedType) {
          console.error('VP Flow: selected case video failed to load', video.error);
          if (video === currentVisualVideo) {
            activateVisualVideo(null);
          } else {
            video.pause();
          }
        }
      });

      // 'loadeddata' (first frame decoded, readyState 2) is enough to swap
      // the video in — Android often fires 'canplay' noticeably later, and
      // renderVisual() only needs readyState >= 2. Keep 'canplay' as well
      // for browsers that skip straight past loadeddata.
      video.addEventListener('loadeddata', function () {
        renderVisual();
      });
      video.addEventListener('canplay', function () {
        renderVisual();
      });
    });

    function findVisualVideo(color, type) {
      if (!color) return null;
      return els.visualVideos.find(function (video) {
        return video.getAttribute('data-vp-flow-video-color') === String(color)
          && video.getAttribute('data-vp-flow-visual-video') === type;
      }) || null;
    }

    // Once the video on screen can play, quietly buffer its counterpart for
    // the same colour (step-1/3 ↔ step-2), so "Choose Refill" and "Back"
    // are instant. Waits for the current video first so the two downloads
    // don't fight over a phone's bandwidth.
    function warmCompanionVideo(video) {
      var otherType = video.getAttribute('data-vp-flow-visual-video') === 'step2' ? 'step13' : 'step2';
      var other = findVisualVideo(video.getAttribute('data-vp-flow-video-color'), otherType);
      if (!other || other.preload === 'auto' || other.dataset.vpWarmQueued === 'true') return;

      other.dataset.vpWarmQueued = 'true';
      var go = function () { hydrateFlowVideo(other, 'auto'); };
      if (video.readyState >= 3) {
        go();
      } else {
        video.addEventListener('canplay', go, { once: true });
      }
    }

    // Pre-open warm-up: buffer the video step 1 will show, before the
    // overlay is even open (fired on idle after load and on finger-down
    // on the CTA — see initToggle / initAll).
    root.addEventListener('vp-flow:warm', function () {
      if (state.color) hydrateFlowVideo(findVisualVideo(state.color, 'step13'), 'auto');
    });

    // On open, fetch just the headers of every colour's step-1 video so
    // whichever colour gets tapped can start without a cold request.
    root.addEventListener('vp-flow:open', function () {
      if (saveDataEnabled()) return;
      els.visualVideos.forEach(function (video) {
        if (video.getAttribute('data-vp-flow-visual-video') === 'step13') {
          hydrateFlowVideo(video, 'metadata');
        }
      });
    });

    function renderVisual() {
      var visualState = 'empty';

      if (state.step === 2) {
        visualState = 'refills';
      } else if (state.skipDispenser) {
        visualState = 'skip';
      } else if (state.color) {
        visualState = 'dispensers';
      }

      showVisualState(visualState);

      if (root.hidden) return;

      var expectedType = state.step === 2 ? 'step2' : 'step13';
      var visualKey = state.color + ':' + state.step + ':' + expectedType;
      var requestedVideo = state.color
        ? els.visualVideos.find(function (video) {
          return video.getAttribute('data-vp-flow-video-color') === state.color
            && video.getAttribute('data-vp-flow-visual-video') === expectedType
            && video.querySelector('source[src], source[data-src]');
        })
        : null;

      if (!requestedVideo) {
        lastRequestedVisualKey = null;
        activateVisualVideo(null);
        return;
      }

      var selectionChanged = visualKey !== lastRequestedVisualKey;
      lastRequestedVisualKey = visualKey;

      // Usually already hydrated by a warm-up; if not, this starts it now
      // (or upgrades a 'metadata' preload to full buffering).
      hydrateFlowVideo(requestedVideo, 'auto');
      warmCompanionVideo(requestedVideo);

      els.visualVideos.forEach(function (video) {
        if (video !== requestedVideo && video !== currentVisualVideo && !video.paused) {
          video.pause();
        }
      });

      if (requestedVideo.readyState >= 2) {
        activateVisualVideo(requestedVideo, visualKey, selectionChanged);
        return;
      }

      if (currentVisualVideo && currentVisualVideo !== requestedVideo) {
        if (!root.hidden && requestedVideo.paused) {
          playFlowVideo(requestedVideo);
        }
        return;
      }

      requestedVideo.classList.add('vp-flow__visual-video--active');
      if (!currentVisualVideo) {
        currentVisualVideo = requestedVideo;
        currentVisualKey = visualKey;
      }
      if (!root.hidden && requestedVideo.paused) {
        playFlowVideo(requestedVideo);
      }
    }

    root.addEventListener('vp-flow:open', renderVisual);

    // Swaps every step-3 bundle card's 1-month/3-month image to match
    // whichever CASE color is currently selected — sourced from that case
    // variant's own custom.<N>pebble_1month / custom.<N>pebble_3month
    // metafields, where <N> (1/2/3) is each bundle card's POSITION among
    // the bundle_option blocks (not its actual bundle size/type). Falls
    // back to the bundle product's own featured image (baked in server-
    // side as data-fallback-src) if the matching metafield isn't set for
    // the newly selected color. Same "server renders the default, JS
    // keeps them in sync with the selected case.
    function updateBundleImagesForColor() {
      var colorData = state.color && data.colors ? data.colors[state.color] : null;

      root.querySelectorAll('[data-vp-flow-bundle-image]').forEach(function (wrap) {
        var freq = wrap.getAttribute('data-vp-flow-bundle-image'); // '1month' | '3month'
        var position = wrap.getAttribute('data-vp-flow-bundle-position');
        var imgEl = wrap.querySelector('[data-vp-flow-bundle-image-el]');
        if (!position || !imgEl) return;

        var key = 'bundle' + position + (freq === '3month' ? 'Image3Month' : 'Image1Month');
        var url = (colorData && colorData[key]) || imgEl.getAttribute('data-fallback-src') || '';

        if (url) {
          imgEl.src = url;
          imgEl.hidden = false;
        } else {
          imgEl.hidden = true;
        }
      });
    }

    /* ---------------------------------------------------------------------
     * Step 1: case color + skip-dispenser
     * ------------------------------------------------------------------- */

    function initColorPicker() {
      var colorButtons = root.querySelectorAll('[data-vp-flow-color]');

      colorButtons.forEach(function (button) {
        // Finger-down lands ~100–300ms before 'click' on touch screens —
        // start buffering this colour's video in that gap.
        button.addEventListener('pointerdown', function () {
          if (button.disabled) return;
          hydrateFlowVideo(findVisualVideo(button.getAttribute('data-color-key'), 'step13'), 'auto');
        }, { passive: true });

        button.addEventListener('click', function () {
          state.color = button.getAttribute('data-color-key');
          state.skipDispenser = false;

          colorButtons.forEach(function (el) {
            el.toggleAttribute('selected', el === button);
          });

          if (els.skipDispenserBtn) els.skipDispenserBtn.classList.remove('vp-flow__skip-dispenser-btn--active');
          if (els.skipDispenserCheck) els.skipDispenserCheck.hidden = true;

          renderVisual();
          updateContinueState();
          updateBundleImagesForColor();
        });
      });

      if (els.skipDispenserBtn) {
        els.skipDispenserBtn.addEventListener('click', function () {
          state.skipDispenser = true;
          state.color = null;

          colorButtons.forEach(function (el) { el.removeAttribute('selected'); });
          els.skipDispenserBtn.classList.add('vp-flow__skip-dispenser-btn--active');
          if (els.skipDispenserCheck) els.skipDispenserCheck.hidden = false;

          renderVisual();
          updateContinueState();
        });
      }
    }

    /* ---------------------------------------------------------------------
     * Step 2: adults/kids tabs, refill tier picker, nutrient bars
     * ------------------------------------------------------------------- */

    function initRefillTabs() {
      var tabs = root.querySelectorAll('[data-vp-refill-tab]');
      var panels = root.querySelectorAll('[data-vp-refill-tab-content]');
      if (!tabs.length) return;

      var kidsRefill = null;

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-vp-refill-tab');
          tabs.forEach(function (t) { t.classList.toggle('vp-flow__refill-tab--active', t === tab); });
          panels.forEach(function (panel) {
            panel.hidden = panel.getAttribute('data-vp-refill-tab-content') !== key;
          });

          var panel = root.querySelector('[data-vp-refill-tab-content="' + key + '"]');
          var cards = panel ? panel.querySelectorAll('[data-vp-flow-refill]') : [];

          if (key === 'kids') {
            var activeKidsCard = panel.querySelector('.vp-flow__refill-card--active[data-vp-flow-refill]');
            if (!activeKidsCard) {
              activeKidsCard = Array.prototype.slice.call(cards).filter(function (c) {
                return c.getAttribute('data-vp-flow-unavailable') !== 'true';
              })[0] || cards[0];
            }
            state.refill = activeKidsCard ? activeKidsCard.getAttribute('data-refill-key') : null;
            kidsRefill = state.refill;
          } else {
            state.refill = state.adultRefill;
          }

          root.querySelectorAll('[data-vp-flow-refill]').forEach(function (card) {
            card.classList.toggle('vp-flow__refill-card--active', card.getAttribute('data-refill-key') === state.refill);
          });
          updateContinueState();
          updateBundlePricesForFrequency();
        });
      });
    }

    function initRefillPicker() {
      var cards = root.querySelectorAll('[data-vp-flow-refill]');

      // Default to the first adult refill, and remember which card was
      // already marked active server-side so the two states start in sync.
      var preselected = root.querySelector('.vp-flow__refill-card--active[data-vp-flow-refill]');
      if (!preselected && cards.length) preselected = cards[0];
      if (preselected) {
        var preselectedKey = preselected.getAttribute('data-refill-key');
        state.refill = preselectedKey;
        state.adultRefill = preselectedKey;
        cards.forEach(function (el) {
          el.classList.toggle('vp-flow__refill-card--active', el === preselected);
        });
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          if (card.getAttribute('data-vp-flow-unavailable') === 'true') return;

          var key = card.getAttribute('data-refill-key');
          state.refill = key;
          var refillData = data.refills && data.refills[key];
          if (!refillData || !refillData.isKids) state.adultRefill = key;

          cards.forEach(function (el) {
            el.classList.toggle('vp-flow__refill-card--active', el === card);
          });
          updateContinueState();
          updateBundlePricesForFrequency();
        });
      });
    }

    function animateBars(step) {
      step.querySelectorAll('[data-vp-flow-bar]').forEach(function (bar) {
        var target = bar.getAttribute('data-target') || 0;
        window.requestAnimationFrame(function () {
          bar.style.width = target + '%';
        });
      });
    }

    /* ---------------------------------------------------------------------
     * Step 3: bundle picker (Just Me / Couples / Family)
     * ------------------------------------------------------------------- */

    function initBundlePicker() {
      var options = root.querySelectorAll('[data-vp-flow-bundle-option]');

      var preselected = root.querySelector('.vp-flow__bundle-option--active[data-vp-flow-bundle-option]');
      if (preselected) state.bundle = preselected.getAttribute('data-bundle-key');
      updateFreqBlockState();

      options.forEach(function (option) {
        option.addEventListener('click', function () {
          state.bundle = option.getAttribute('data-bundle-key');
          options.forEach(function (el) {
            el.classList.toggle('vp-flow__bundle-option--active', el === option);
          });
          updateContinueState();
          updateFreqBlockState();
          updateBundlePricesForFrequency();
          prefetchBundleSelection(option, state.frequency);
        });
      });
    }

    /* ---------------------------------------------------------------------
     * Step navigation
     * ------------------------------------------------------------------- */

    function isStepValid(stepNum) {
      if (stepNum === 1) return Boolean(state.color || state.skipDispenser);
      if (stepNum === 2) return Boolean(state.refill);
      if (stepNum === 3) return Boolean(state.bundle);
      return true;
    }

    function updateContinueState() {
      els.continueButtons.forEach(function (btn) {
        // Never let a selection change (colour/refill/bundle picker) undo
        // the busy-state disabling from setContinueBusy(true) — otherwise
        // switching bundles while an add-to-cart is still resolving would
        // visually re-enable the button before the in-flight request settles.
        btn.disabled = state.isAddingToCart || !isStepValid(state.step);
      });
    }

    function showStep(stepNum) {
      state.step = stepNum;

      els.steps.forEach(function (step) {
        var isActive = Number(step.getAttribute('data-vp-flow-step')) === stepNum;
        step.hidden = !isActive;
        step.classList.toggle('vp-flow__step--active', isActive);

        if (isActive && stepNum === 2) {
          window.setTimeout(function () { animateBars(step); }, 100);
        }
      });

      if (stepNum === 2) trackStepView(2, 'refills');
      if (stepNum === 3) {
        trackStepView(3, 'bundle');
        // Kick off the ReCharge bundle-selection resolve for whatever's
        // currently selected as soon as this step becomes visible — by
        // the time the customer reviews it and hits Add to Cart, the
        // network round trip is usually already done.
        var currentBundleEl = state.bundle ? root.querySelector('[data-bundle-key="' + state.bundle + '"]') : null;
        prefetchBundleSelection(currentBundleEl, state.frequency);
      }

      els.stepIcons.forEach(function (block) {
        block.hidden = Number(block.getAttribute('data-vp-flow-step')) !== stepNum;
      });

      els.continueButtons.forEach(function (btn) {
        btn.hidden = Number(btn.getAttribute('data-vp-flow-continue-step')) !== stepNum;
      });

      updateFreqBlockState();

      // Back button stays visible on every step, including step 1 — on
      // step 1 it closes the flow overlay instead of navigating back.

      dots.forEach(function (dot, i) {
        dot.classList.toggle('vp-flow__dot--active', i === stepNum - 1);
        dot.classList.toggle('vp-flow__dot--previous', i < stepNum - 1);
      });

      renderVisual();
      updateContinueState();
      // updateRefillCardPrices();

      if (els.stepsWrap) els.stepsWrap.scrollTop = 0;
    }

    function goToStep(stepNum) {
      if (stepNum < 1 || stepNum > els.steps.length) return;
      showStep(stepNum);
    }

    /* ---------------------------------------------------------------------
     * Add to cart (step 3 → continue) — the bundle IS the sellable
     * product (single default variant, ReCharge selling plans for
     * 1-month/3-month). Case/refill choices from steps 1-2 are attached
     * as line item properties for display, since they're not separate
     * SKUs inside the bundle.
     * ------------------------------------------------------------------- */

    function currencyFormat(amount) {
      var symbol = data.currencySymbol || '£';
      return symbol + Number(amount || 0).toFixed(2);
    }

    function getBundlePlans(bundleEl) {
      try {
        return JSON.parse(bundleEl.getAttribute('data-plans') || '{}');
      } catch (err) {
        return {};
      }
    }

    // NOTE: quantity:N on a single selection entry IS the correct,
    // documented shape — confirmed against Recharge's own "Bundles
    // Overview" SDK docs (selections[].quantity is documented as "number
    // of items" on one entry) and this bundle's own getCDNBundleSettings
    // response, whose selection_defaults for the "2 Pebbles" bundle is
    // exactly [{ external_variant_id: ..., quantity: 2 }] — one entry,
    // not two. An earlier revision here split quantity:N into N separate
    // quantity:1 entries based on a misreading of a support example that
    // used two DIFFERENT variant IDs (two different flavours) — that
    // reasoning didn't hold up, so that expansion has been removed.

    // Step 2's refill card prices show a single static "best value"
    // per-refill price — NOT reactive to the step-3 frequency toggle or
    // to which bundle the customer ends up choosing. Across every bundle
    // option present (1/2/3 Pebbles, fixed or dynamic), find whichever
    // one has the HIGHEST 3-month refill count (naturally the biggest
    // bundle, e.g. "3 Pebbles" — buying more refills at once is what
    // unlocks the best per-unit price) and use THAT bundle's real
    // 3-month plan price divided by its own refills count as the
    // per-refill price shown on every card. This intentionally replaces
    // an earlier version that recalculated per-card prices live off the
    // 1-Pebble bundle specifically, reacting to whichever frequency was
    // selected in step 3 — that reactive behavior has been removed.
    function getBestRefillUnitPrice() {
      var best = null;
      root.querySelectorAll('[data-vp-flow-bundle-option]').forEach(function (bundleEl) {
        var plans = getBundlePlans(bundleEl);
        var plan = plans['1month'];
        var refills = plan && parseInt(plan.refills, 10);
        var price = plan && parseFloat(plan.price);
        if (!refills || !price) return;
        if (!best || refills > best.refills) {
          best = { refills: refills, price: price };
        }
      });
      if (!best) return null;
      return best.price / best.refills;
    }

    function updateRefillCardPrices() {
      var unitPrice = getBestRefillUnitPrice();
      if (unitPrice == null) return;
      root.querySelectorAll('[data-vp-flow-refill]').forEach(function (card) {
        var priceEl = card.querySelector('.vp-flow__refill-price');
        if (!priceEl) return;
        priceEl.textContent = currencyFormat(unitPrice);
      });
    }

    // Dynamic bundles carry no real price on their own variant — price
    // and the 3-month discount live on whichever refill variant is
    // currently selected (per ReCharge's bundle-scoped selling plans).
    // Recomputed live as the customer changes their refill choice, not
    // just at page load.
    function getEffectivePlans(bundleEl) {
      var staticPlans = getBundlePlans(bundleEl);
      if (bundleEl.getAttribute('data-is-dynamic') !== 'true') return staticPlans;

      var refillData = state.refill && data.refills ? data.refills[state.refill] : null;
      if (!refillData) return staticPlans;

      var discountPct = parseFloat(bundleEl.getAttribute('data-dynamic-discount-pct')) || 0;
      var unitPrice = refillData.price;
      var unitCompare = refillData.compareAt > unitPrice ? refillData.compareAt : unitPrice;
      var unitPrice3 = Math.round(unitPrice * (100 - discountPct) / 100 * 100) / 100;

      // Case's own compare-at, folded into the compare-at (savings) figure
      // only — display only. The Case still charges as its own separate
      // one-time cart line (finalizeBundleAdd) and its real price is never
      // added into the subscription price shown here, but its retail value
      // still counts toward the shown savings (e.g. a free case's value),
      // same as the liquid template's initial-render calc. Case count
      // never scales with frequency, so this is the same flat addition at
      // both 1-month and 3-month.
      var caseData = state.color && data.colors ? data.colors[state.color] : null;
      var caseCompare = 0;
      if (caseData) {
        caseCompare = caseData.compareAt > 0 ? caseData.compareAt : 0;
        if (!caseCompare && data.dispenser && data.dispenser.isFree) {
          caseCompare = caseData.price || 0;
        }
      }

      var qty1 = parseInt(staticPlans['1month'] && staticPlans['1month'].refills, 10) || 1;
      var qty3 = parseInt(staticPlans['3month'] && staticPlans['3month'].refills, 10) || 1;

      // Real totals for however many refill units this frequency actually
      // adds — not the single-unit price. 1-month's qty is always 1 so
      // this is a no-op there, but 3-month genuinely adds multiple real
      // line items and the displayed price has to match what gets charged.
      // Price stays refill-only — the Case is charged as its own separate
      // one-time cart line (finalizeBundleAdd) and should not inflate the
      // subscription price shown here. Compare-at still folds the Case's
      // retail value in, so the displayed "you save" figure reflects the
      // full basket (refill discount + case's own value/free-case value).
      var price1 = Math.round((unitPrice * qty1) * 100) / 100;
      var compare1 = Math.round((unitCompare * qty1 + caseCompare) * 100) / 100;
      var price3 = Math.round((unitPrice3 * qty3) * 100) / 100;
      var compare3 = Math.round((unitCompare * qty3 + caseCompare) * 100) / 100;

      function toPlan(price, compareVal, staticPlan) {
        var servings = staticPlan ? parseInt(staticPlan.servings, 10) : 0;
        return {
          sellingPlanId: staticPlan ? staticPlan.sellingPlanId : null,
          name: staticPlan ? staticPlan.name : '',
          fullName: staticPlan ? staticPlan.fullName : '',
          description: staticPlan ? staticPlan.description : '',
          price: price,
          compareAt: compareVal,
          perServe: servings > 0 ? price / servings : 0,
          save: compareVal > price ? (compareVal - price) : 0,
          discountPct: staticPlan ? (parseInt(staticPlan.discountPct, 10) || 0) : 0,
          productId: staticPlan ? staticPlan.productId : null,
          variantId: staticPlan ? staticPlan.variantId : null,
          cases: staticPlan ? staticPlan.cases : null,
          refills: staticPlan ? staticPlan.refills : null
        };
      }

      return {
        '1month': toPlan(price1, compare1, staticPlans['1month']),
        '3month': toPlan(price3, compare3, staticPlans['3month'])
      };
    }

    /* ---------------------------------------------------------------------
     * Add to cart (step 3 → continue). 1x bundles add the bundle variant
     * directly. 2x/4x bundles use every slot filled with the real step
     * 1/2 choice (e.g. 4-pebble bundle + Dark Forest + Plus = 4x Dark
     * Forest cases + 4x Plus refills) — overridden via ReCharge's bundle
     * selection engine (getBundleId), which replaces whatever defaults
     * were configured in the ReCharge bundle itself.
     * ------------------------------------------------------------------- */

    var rechargeInitPromise = null;

    function initRecharge() {
      if (rechargeInitPromise) return rechargeInitPromise;

      rechargeInitPromise = new Promise(function (resolve, reject) {
        if (typeof window.recharge === 'undefined') {
          reject(new Error('ReCharge SDK not loaded — check the Storefront token setting.'));
          return;
        }
        if (!data.recharge || !data.recharge.storeDomain || !data.recharge.storefrontToken) {
          reject(new Error('ReCharge store domain / storefront token not configured.'));
          return;
        }
        try {
          window.recharge.init({
            storeIdentifier: data.recharge.storeDomain,
            storefrontAccessToken: data.recharge.storefrontToken
          });
          resolve(window.recharge);
        } catch (err) {
          reject(err);
        }
      });

      return rechargeInitPromise;
    }

    function generateBundleInstanceId() {
      return 'vpb_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
    }

    // Single control point for "an add-to-cart is in progress" — keeps
    // the continue button(s)' disabled state and state.isAddingToCart in
    // lockstep so there's exactly one place that can turn busy-mode on or
    // off, instead of several independent `btn.disabled = ...` call sites
    // that could drift out of sync with each other.
    function setContinueBusy(isBusy) {
      state.isAddingToCart = isBusy;
      els.continueButtons.forEach(function (btn) { btn.disabled = isBusy; });
    }

    /* ---------------------------------------------------------------------
     * Bundle selection prefetch cache.
     *
     * getBundleId/validateBundle/getDynamicBundleItems (below) are pure
     * functions of (bundle, frequency, refill) — never of case colour,
     * which is only ever used for cart-line display properties. That
     * means the whole ReCharge round trip can be resolved speculatively,
     * as soon as those three inputs are known/changed, instead of only
     * starting it after the user clicks Add to Cart — which is what was
     * putting ~1-1.5s of ReCharge network time directly in the critical
     * path of the click.
     *
     * Cache entries are keyed by bundle+frequency+refill and hold the
     * in-flight/resolved promise. addFixedBundleToCart/addDynamicBundleToCart
     * read from this cache first and only fall back to resolving fresh
     * (identical to the old inline behaviour) if nothing has been
     * prefetched yet for the current selection — so a user who clicks
     * Add to Cart before a prefetch has finished sees no change in
     * behaviour, just no speedup for that one click.
     * ------------------------------------------------------------------- */

    var bundleSelectionCache = {};

    function bundleSelectionCacheKey(bundleKey, frequency, refillKey) {
      return String(bundleKey) + '|' + String(frequency) + '|' + String(refillKey || '');
    }

    // Fixed (2/3/4 Pebbles) — resolves to { rbId, activePlan, productId,
    // variantId, cases, refillQty }. Mirrors the network chain that used
    // to live inline in addFixedBundleToCart.
    function resolveFixedBundleSelection(bundleEl, frequency, refillData) {
      if (!refillData || !refillData.variantId) {
        return Promise.reject(new Error('VP Flow: no refill selected yet.'));
      }

      var plans = getBundlePlans(bundleEl);
      var activePlan = plans[frequency];
      if (!activePlan || !activePlan.sellingPlanId || !activePlan.variantId || !activePlan.productId) {
        return Promise.reject(new Error('VP Flow: incomplete plan data for frequency "' + frequency + '".'));
      }

      var variantId = activePlan.variantId;
      var productId = activePlan.productId;
      var cases = parseInt(activePlan.cases, 10) || parseInt(bundleEl.getAttribute('data-cases'), 10) || 1;
      var refillQty = parseInt(activePlan.refills, 10) || cases;
      var refillVariantId = refillData.variantId;

      return initRecharge().then(function (recharge) {
        return recharge.cdn.getCDNBundleSettings(productId).then(function (settings) {
          var variant = settings && settings.variants && settings.variants[0];
          var collectionId = variant && variant.option_sources && variant.option_sources[0]
            ? variant.option_sources[0].collection_id
            : null;

          if (!collectionId) {
            throw new Error('ReCharge did not return a collection_id for this bundle product.');
          }

          var selections = [
            { collectionId: collectionId, externalProductId: data.refillProductId, externalVariantId: refillVariantId, quantity: refillQty }
          ];

          var bundle = {
            externalProductId: productId,
            externalVariantId: variantId,
            selections: selections
          };

          return recharge.bundle.validateBundle(bundle).then(function (isValid) {
            if (isValid !== true) {
              throw new Error('ReCharge bundle validation failed: ' + isValid);
            }
            return recharge.bundle.getBundleId(bundle);
          });
        });
      }).then(function (rbId) {
        return { rbId: rbId, activePlan: activePlan, productId: productId, variantId: variantId, cases: cases, refillQty: refillQty };
      });
    }

    // Dynamic (1 Pebble) — resolves to { cartItems, activePlan, productId,
    // variantId, cases, refillQty, handle }. Mirrors the network chain
    // that used to live inline in addDynamicBundleToCart.
    function resolveDynamicBundleSelection(bundleEl, frequency, refillData) {
      var handle = bundleEl.getAttribute('data-product-handle');
      var cases = parseInt(bundleEl.getAttribute('data-cases'), 10) || 1;
      var bundlePlans = getBundlePlans(bundleEl);
      var activePlan = bundlePlans[frequency];
      if (!activePlan || !activePlan.sellingPlanId || !activePlan.variantId || !activePlan.productId) {
        return Promise.reject(new Error('VP Flow: incomplete plan data for frequency "' + frequency + '".'));
      }

      var productId = activePlan.productId;
      var variantId = activePlan.variantId;
      var refillQty = parseInt(activePlan.refills, 10) || cases;

      var refillVariantId = refillData ? refillData.variantId : null;
      var planKey = frequency === '3month' ? 'plan3SellingPlanId' : 'plan1SellingPlanId';
      var refillSellingPlanId = refillData ? refillData[planKey] : null;

      if (!refillVariantId || !refillSellingPlanId) {
        return Promise.reject(new Error('VP Flow: missing refill data for frequency "' + frequency + '".'));
      }

      return initRecharge().then(function (recharge) {
        return recharge.cdn.getCDNBundleSettings(productId).then(function (settings) {
          var variant = settings && settings.variants && settings.variants[0];
          var collectionId = variant && variant.option_sources && variant.option_sources[0]
            ? variant.option_sources[0].collection_id
            : null;

          if (!collectionId) {
            throw new Error('ReCharge did not return a collection_id for this bundle product.');
          }

          var bundle = {
            externalProductId: productId,
            externalVariantId: variantId,
            selections: [
              { collectionId: collectionId, externalProductId: data.refillProductId, externalVariantId: refillVariantId, quantity: refillQty, sellingPlan: refillSellingPlanId }
            ]
          };

          return recharge.bundle.getDynamicBundleItems(bundle, handle);
        });
      }).then(function (cartItems) {
        if (!cartItems || !cartItems.length) throw new Error('ReCharge returned no dynamic bundle items.');
        return { cartItems: cartItems, activePlan: activePlan, productId: productId, variantId: variantId, cases: cases, refillQty: refillQty, handle: handle };
      });
    }

    // Returns the cache entry for the CURRENT state.refill, resolving
    // (and caching) it on first use for a given key. Returns null when
    // there's nothing to resolve against yet (no refill picked) — callers
    // treat that the same as "nothing prefetched".
    function getCachedBundleSelection(bundleEl, frequency) {
      if (!bundleEl) return null;

      var bundleKey = bundleEl.getAttribute('data-bundle-key');
      var refillData = state.refill && data.refills ? data.refills[state.refill] : null;
      if (!bundleKey || !refillData) return null;

      var isDynamic = bundleEl.getAttribute('data-is-dynamic') === 'true';
      var key = bundleSelectionCacheKey(bundleKey, frequency, state.refill);
      var entry = bundleSelectionCache[key];

      if (!entry) {
        var resolver = isDynamic ? resolveDynamicBundleSelection : resolveFixedBundleSelection;
        entry = bundleSelectionCache[key] = {};
        entry.promise = resolver(bundleEl, frequency, refillData).catch(function (err) {
          // Don't leave a rejected promise cached — a transient failure
          // (network blip, etc.) shouldn't permanently poison this key.
          // The next prefetch trigger or the Add to Cart click itself
          // will simply try again.
          if (bundleSelectionCache[key] === entry) delete bundleSelectionCache[key];
          throw err;
        });
      }

      return entry;
    }

    // Fire-and-forget speculative resolve. Called when the inputs that
    // determine the ReCharge selection become known/change (reaching
    // step 3, switching bundle, switching frequency) — well before the
    // user has clicked Add to Cart. Errors are swallowed here; they'll
    // surface normally if/when the user actually clicks, via the fallback
    // path in addFixedBundleToCart/addDynamicBundleToCart.
    function prefetchBundleSelection(bundleEl, frequency) {
      var entry = getCachedBundleSelection(bundleEl, frequency);
      if (entry) entry.promise.catch(function () {});
    }

    // Adds the refill line(s) (already fully resolved — real recurring
    // ReCharge selection, refill-only) plus, alongside them in the SAME
    // /cart/add.js call, the Case as a separate ONE-TIME line (no
    // selling_plan) — quantity = however many cases this bundle size
    // includes, variant = whatever colour was picked in Step 1. Both
    // dynamic (1 Pebble) and fixed (2/3/4 Pebbles) bundles go through
    // this exact same path now; only how the refill line's own
    // price/plan was computed differs upstream. The two are linked by a
    // shared _bundle_instance_id property so the cart drawer can find the
    // Case line(s) belonging to a given refill/subscription line and
    // render them together as one card pair — same idea as the old
    // _rc_bundle linking key, generalised to every bundle size.
    function finalizeBundleAdd(refillItems, caseData, cases, bundleInstanceId) {
      const root = window.Shopify.routes.root;
      var items = refillItems.slice();

      if (caseData && caseData.variantId) {
        items.push({
          id: caseData.variantId,
          quantity: cases,
          properties: {
            'Case Colour': caseData.label,
            '_bundle_instance_id': bundleInstanceId,
            '_is_case_line': 'true',
            '_pebble_case': 'true'
          }
        });
      }

      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function (result) {
          if (typeof window.checkFreeShipping === 'function') window.checkFreeShipping();
          if (window.VpCart && window.VpCart.open) window.VpCart.open();

          // `value` sums final_line_price (cents, includes line-level
          // discounts) across just the items this call added — not the
          // whole cart — so a repeat add-to-cart in the same session
          // doesn't inflate later AddToCart events with earlier totals.
          var addedItems = (result && result.items) || [];
          var value = addedItems.reduce(function (sum, addedItem) {
            return sum + (addedItem.final_line_price || 0);
          }, 0) / 100;
          var refillProps = (refillItems[0] && refillItems[0].properties) || {};

          trackTriplePixel('PebbleV2AddToCart', {
            step: 3,
            label: 'add_to_cart',
            case_colour: caseData ? String(caseData.label) : '',
            refill_type: refillProps['Refill Type'] || '',
            bundle_type: refillProps['Bundle Type'] || '',
            value: value,
            currency: data.currencyCode || ''
          });
        })
        .catch(function (err) {
          console.error('VP Flow: add to cart failed', err);
        })
        .then(function () {
          if(!localStorage.getItem("fixed_cart_currency")) {
            setTimeout(function(){
              setContinueBusy(false);
            }, 2500);
            localStorage.setItem("fixed_cart_currency", true);
          } else {
            setContinueBusy(false);
          }
        });
    }

    // Add to cart (step 3 → continue). Both bundle types add the Case as
    // its own separate one-time line (finalizeBundleAdd), and both now
    // have two real per-frequency Shopify variants ("1 Month Supply" /
    // "3 Month Supply") — but the RECURRING refill mechanism still
    // differs by real financial necessity:
    //
    // - Dynamic (1 Pebble): the bundle's own "1 Month Supply"/"3 Month
    //   Supply" variants are priced at $0 — price is per-flavour and real
    //   SKU prices can differ by flavour, so there's no single static
    //   price any one SKU could carry. Only ReCharge's
    //   getDynamicBundleItems() actually prices this correctly — it
    //   returns the REAL refill variant as the cart line, natively priced
    //   by Shopify from that variant's own selling-plan price × the real
    //   selection quantity. Using getBundleId() here (as fixed bundles
    //   do) would add the bundle's own $0 placeholder SKU as the cart
    //   line, which has no real price of its own. (This bit us in an
    //   earlier revision — see addDynamicBundleToCart.)
    // - Fixed (2/3/4 Pebbles): "1 Month" / "3 Month" are two real Shopify
    //   variants (the "Supply" option), each with a real absolute price
    //   configured directly on the plan — getBundleId() just tells
    //   ReCharge which real products to ship, the charge itself already
    //   lives on that variant/plan.
    function addSelectionToCart() {
      // Belt-and-suspenders guard: if an add-to-cart is already in
      // flight (e.g. the customer double-clicked, or clicked before the
      // buttons visually updated), bail out immediately rather than
      // starting a second one. This is independent of the button's own
      // `disabled` attribute so it holds even if that's ever bypassed.
      if (state.isAddingToCart) return;

      var bundleEl = state.bundle ? root.querySelector('[data-bundle-key="' + state.bundle + '"]') : null;
      if (!bundleEl) return;

      if (bundleEl.getAttribute('data-is-dynamic') === 'true') {
        addDynamicBundleToCart(bundleEl);
        return;
      }

      addFixedBundleToCart(bundleEl);
    }

    // Dynamic (1 Pebble): REFILL-ONLY selection (Case is never part of
    // it — added separately as a one-time line via finalizeBundleAdd).
    // getDynamicBundleItems() returns the real refill variant as an
    // already-correctly-priced cart item — quantity is the real number
    // of refill units this frequency adds, and Shopify computes the true
    // charge natively from that variant's own selling-plan price, so
    // there's no placeholder-SKU pricing gap to work around.
    //
    // The bundle's own product/variant now comes from bundlePlans[freq]
    // (same source fixed bundles use) rather than a static data-variant-id
    // attribute, since "1 Month Supply" and "3 Month Supply" are two real
    // variants now — which one is "the bundle variant" depends on which
    // frequency is active, not a single shared value.
    function addDynamicBundleToCart(bundleEl) {
      var bundleTitleEl = bundleEl.querySelector('.vp-flow__bundle-name');
      var bundleTitle = bundleTitleEl ? bundleTitleEl.textContent.trim() : '';

      var caseData = state.color && data.colors ? data.colors[state.color] : null;
      var refillData = state.refill ? data.refills[state.refill] : null;

      var planKey = state.frequency === '3month' ? 'plan3SellingPlanId' : 'plan1SellingPlanId';
      var refillSellingPlanId = refillData ? refillData[planKey] : null;

      if (!refillData || !refillData.variantId || !refillSellingPlanId) {
        console.error('VP Flow: cannot add dynamic bundle — missing refill data for frequency "' + state.frequency + '"', {
          refillVariantId: refillData ? refillData.variantId : null,
          refillSellingPlanId: refillSellingPlanId,
          selectedRefill: state.refill
        });
        return;
      }

      setContinueBusy(true);

      var bundlePlans = getBundlePlans(bundleEl);

      // Normally already resolved by prefetchBundleSelection (triggered on
      // reaching step 3 / switching bundle / switching frequency) — this
      // just reads the cached promise. Falls back to resolving fresh here
      // (same network chain, same cost as before) if nothing was
      // prefetched yet for the current selection.
      var entry = getCachedBundleSelection(bundleEl, state.frequency);
      if (!entry) {
        console.error('VP Flow: cannot add dynamic bundle — no refill selected.');
        setContinueBusy(false);
        return;
      }

      entry.promise.then(function (resolved) {
        var bundleInstanceId = generateBundleInstanceId();
        var cases = resolved.cases;
        var refillQty = resolved.refillQty;

        var discountPct = parseFloat(bundleEl.getAttribute('data-dynamic-discount-pct')) || 0;
        var unitPrice = refillData.price;
        var unitCompare = refillData.compareAt > unitPrice ? refillData.compareAt : unitPrice;
        var unitPrice3 = Math.round(unitPrice * (100 - discountPct) / 100 * 100) / 100;

        // Refill-only compare-at — the Case is always its own separate
        // real cart line (finalizeBundleAdd), which contributes its own
        // real compare-at to the cart summary independently. Folding the
        // Case's compare-at in here too would double-count it in the
        // summary AND make the refill card itself show case+refill
        // combined, where only the refill's own compare-at belongs.
        var qty1 = parseInt(bundlePlans['1month'] && bundlePlans['1month'].refills, 10) || cases;
        var qty3 = parseInt(bundlePlans['3month'] && bundlePlans['3month'].refills, 10) || cases;
        var refillPrice1 = Math.round(unitPrice * qty1 * 100) / 100;
        var refillCompare1 = Math.round(unitCompare * qty1 * 100) / 100;
        var refillPrice3 = Math.round(unitPrice3 * qty3 * 100) / 100;
        var refillCompare3 = Math.round(unitCompare * qty3 * 100) / 100;

        // Build fresh item objects rather than mutating resolved.cartItems
        // in place — the cache entry may still be referenced/reused (e.g.
        // the same selection resolved again after a failed add), so the
        // cached items themselves should stay untouched.
        var items = resolved.cartItems.map(function (item) {
          return Object.assign({}, item, {
            properties: Object.assign({}, item.properties, {
              'Case Colour': caseData ? String(caseData.label) : '',
              'Refill Type': new Array(cases).fill(refillData.name).join(', '),
              'Bundle Type': bundleTitle,
              '_Units': String(cases),
              '_RefillMultiplier': String(Math.round(refillQty / cases) || 1),
              '_bundle_instance_id': bundleInstanceId,
              '_is_dynamic': 'true',
              '_bundle_product_id': resolved.productId,
              '_bundle_variant_id': resolved.variantId,
              '_bundle_product_handle': resolved.handle,
              '_bundle_plans': JSON.stringify(bundlePlans),
              '_plan_1month_label': bundlePlans['1month'] ? String(bundlePlans['1month'].name || '') : '',
              '_plan_3month_label': bundlePlans['3month'] ? String(bundlePlans['3month'].name || '') : '',
              '_plan_1month_note': bundlePlans['1month'] ? String(bundlePlans['1month'].description || bundlePlans['1month'].fullName || bundlePlans['1month'].name || '') : '',
              '_plan_3month_note': bundlePlans['3month'] ? String(bundlePlans['3month'].description || bundlePlans['3month'].fullName || bundlePlans['3month'].name || '') : '',
              '_discount_pct_1month': bundlePlans['1month'] ? String(bundlePlans['1month'].discountPct || 0) : '0',
              '_discount_pct_3month': bundlePlans['3month'] ? String(bundlePlans['3month'].discountPct || 0) : '0',
              '_refill_qty_1month': String(qty1),
              '_refill_qty_3month': String(qty3),
              '_selling_plan_1month': String(refillData.plan1SellingPlanId || ''),
              '_selling_plan_3month': String(refillData.plan3SellingPlanId || ''),
              '_price_1month': String(refillPrice1),
              '_price_3month': String(refillPrice3),
              '_compare_1month': String(refillCompare1),
              '_compare_3month': String(refillCompare3)
            })
          });
        });

        return finalizeBundleAdd(items, caseData, cases, bundleInstanceId);
      }).catch(function (err) {
        console.error('VP Flow: dynamic bundle add to cart failed', err);
        setContinueBusy(false);
      });
    }

    // Fixed (2/3/4 Pebbles): REFILL-ONLY getBundleId() selection against
    // this frequency's own real "Supply" variant, which already carries
    // its true absolute price/plan — Case is added separately as a
    // one-time line via finalizeBundleAdd.
    function addFixedBundleToCart(bundleEl) {
      var plans = getBundlePlans(bundleEl);
      var bundleTitleEl = bundleEl.querySelector('.vp-flow__bundle-name');
      var bundleTitle = bundleTitleEl ? bundleTitleEl.textContent.trim() : '';

      var caseData = state.color && data.colors ? data.colors[state.color] : null;
      var refillData = state.refill && data.refills ? data.refills[state.refill] : null;

      // Refill is mandatory — without it there's nothing to build a
      // recurring selection from.
      if (!refillData || !refillData.variantId) return;

      setContinueBusy(true);

      // Normally already resolved by prefetchBundleSelection (triggered on
      // reaching step 3 / switching bundle / switching frequency) — this
      // just reads the cached promise. Falls back to resolving fresh here
      // (same network chain, same cost as before) if nothing was
      // prefetched yet for the current selection.
      var entry = getCachedBundleSelection(bundleEl, state.frequency);
      if (!entry) {
        setContinueBusy(false);
        return;
      }

      entry.promise.then(function (resolved) {
        var activePlan = resolved.activePlan;
        var cases = resolved.cases;
        var refillQty = resolved.refillQty;
        // Cart-line quantity multiplier — read from the selling plan's own
        // "Product Quantity" option (already resolved server-side into
        // cartQty on this plan). Always 1 in practice (see vp-flow.liquid),
        // since scaling lives entirely in the Refill selection, never in
        // the cart line's own quantity.
        var cartQty = parseInt(activePlan.cartQty, 10) || 1;

        var bundleInstanceId = generateBundleInstanceId();

        var qty1 = parseInt(plans['1month'] && plans['1month'].refills, 10) || cases;
        var qty3 = parseInt(plans['3month'] && plans['3month'].refills, 10) || cases;
        var discountPct1 = plans['1month'] ? (parseInt(plans['1month'].discountPct, 10) || 0) : 0;
        var discountPct3 = plans['3month'] ? (parseInt(plans['3month'].discountPct, 10) || 0) : 0;

        // Base properties every refill line carries — structured (not flat
        // display strings) so the cart drawer can independently resolve
        // dropdown options/images and rebuild a new ReCharge selection
        // later if the customer edits it.
        var refillProperties = {};
        if (caseData) refillProperties['Case Colour'] = new Array(cases).fill(caseData.label).join(', ');
        refillProperties['Refill Type'] = new Array(cases).fill(refillData.name).join(', ');
        refillProperties['Bundle Type'] = bundleTitle;
        refillProperties['_Units'] = String(cases);
        refillProperties['_RefillMultiplier'] = String(Math.round(refillQty / cases) || 1);
        refillProperties['_bundle_instance_id'] = bundleInstanceId;
        refillProperties['_is_dynamic'] = 'false';
        refillProperties['_bundle_plans'] = JSON.stringify(plans);
        refillProperties['_plan_1month_label'] = plans['1month'] ? String(plans['1month'].name || '') : '';
        refillProperties['_plan_3month_label'] = plans['3month'] ? String(plans['3month'].name || '') : '';
        refillProperties['_plan_1month_note'] = plans['1month'] ? String(plans['1month'].description || plans['1month'].fullName || plans['1month'].name || '') : '';
        refillProperties['_plan_3month_note'] = plans['3month'] ? String(plans['3month'].description || plans['3month'].fullName || plans['3month'].name || '') : '';
        refillProperties['_discount_pct_1month'] = String(discountPct1 || 0);
        refillProperties['_discount_pct_3month'] = String(discountPct3 || 0);
        if (plans['1month'] && plans['1month'].sellingPlanId) refillProperties['_selling_plan_1month'] = String(plans['1month'].sellingPlanId);
        if (plans['3month'] && plans['3month'].sellingPlanId) refillProperties['_selling_plan_3month'] = String(plans['3month'].sellingPlanId);
        refillProperties['_price_1month'] = plans['1month'] ? String(plans['1month'].price) : '';
        refillProperties['_price_3month'] = plans['3month'] ? String(plans['3month'].price) : '';
        // Refill-only compare-at (excludes case_compare_total) — the Case
        // is always its own separate real cart line (finalizeBundleAdd),
        // which contributes its own real compare-at to the cart summary
        // independently. Storing the case-inclusive plans[freq].compareAt
        // here instead would double-count the Case in the cart summary AND
        // show a case+refill combined figure on the refill card itself,
        // where only the refill's own compare-at belongs.
        if (plans['1month'] && plans['1month'].refillCompareAt > 0) refillProperties['_compare_1month'] = String(plans['1month'].refillCompareAt);
        if (plans['3month'] && plans['3month'].refillCompareAt > 0) refillProperties['_compare_3month'] = String(plans['3month'].refillCompareAt);
        refillProperties['_refill_qty_1month'] = String(qty1);
        refillProperties['_refill_qty_3month'] = String(qty3);

        var properties = Object.assign({}, refillProperties, {
          '_rb_id': resolved.rbId,
          '_bundle_product_id': resolved.productId
        });
        var refillItem = { id: resolved.variantId, quantity: cartQty, selling_plan: activePlan.sellingPlanId, properties: properties };
        return finalizeBundleAdd([refillItem], caseData, cases, bundleInstanceId);
      }).catch(function (err) {
        console.error('VP Flow: bundle add to cart failed', err);
        setContinueBusy(false);
      });
    }



    function initNav() {
      if (els.backButton) {
        els.backButton.addEventListener('click', function () {
          if (state.step === 1) {
            hideFlowOverlay();
            return;
          }
          goToStep(state.step - 1);
        });
      }
      els.continueButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;

          if (state.step === 3) {
            addSelectionToCart();
            return;
          }

          goToStep(state.step + 1);
        });
      });
    }

    /* ---------------------------------------------------------------------
     * Delivery frequency tabs (1-month / 3-month) — switches which
     * selling plan is active and updates every bundle card's displayed
     * price/compare/per-serve/savings to match.
     * ------------------------------------------------------------------- */

    // Every bundle's label and savings-badge text is pre-rendered by
    // Liquid (see freq_tabs_markup in vp-flow.liquid) — one whole tab
    // group per bundle, all sitting in the DOM from page load. This
    // function's only job is toggling `hidden` on the selected bundle
    // group. It must NEVER set textContent/innerHTML on these elements — doing so would
    // overwrite whatever a translator (e.g. Weglot on a /de-eu subpath)
    // already translated, and since this runs again every time step 3
    // is (re)shown, a translated string would get stomped back to raw
    // English the second time a customer reaches step 3. Same fix
    // already applied to the back/continue buttons: their label text is
    // Liquid-only, and JS only ever toggles their hidden/disabled state.
    function updateFreqBlockState() {
      if (!els.freqBlock) return;

      var bundleEl = state.bundle ? root.querySelector('[data-bundle-key="' + state.bundle + '"]') : null;
      var plans = bundleEl ? getEffectivePlans(bundleEl) : {};
      var hasBothPlans = Boolean(plans['1month'] && plans['1month'].sellingPlanId && plans['3month'] && plans['3month'].sellingPlanId);

      els.freqBlock.hidden = !(state.step === 3 && hasBothPlans);
      if (!hasBothPlans) return;

      // Show only the pre-rendered group belonging to the selected bundle.
      root.querySelectorAll('[data-vp-flow-freq-for]').forEach(function (group) {
        group.hidden = group.getAttribute('data-vp-flow-freq-for') !== state.bundle;
      });

      applyFreqTabActiveState();
    }

    // Keep whatever frequency was already selected (switching bundles
    // shouldn't silently revert a 3-month choice back to 1-month).
    function applyFreqTabActiveState() {
      root.querySelectorAll('[data-vp-flow-freq-tab]').forEach(function (tab) {
        tab.classList.toggle('vp-flow__freq-tab--active', tab.getAttribute('data-vp-flow-freq-tab') === state.frequency);
      });
    }

    function updateBundlePricesForFrequency() {
      root.querySelectorAll('[data-vp-flow-dynamic-refill-name-for]').forEach(function (nameEl) {
        nameEl.hidden = nameEl.getAttribute('data-vp-flow-dynamic-refill-name-for') !== String(state.refill);
      });

      root.querySelectorAll('[data-vp-flow-bundle-option]').forEach(function (bundleEl) {
        try {
          var plans = getEffectivePlans(bundleEl);
          var plan = plans[state.frequency];
          var baselinePlan = plans['1month'];
          if (!plan || !baselinePlan) {
            console.error('VP Flow: no plan data for bundle', bundleEl.getAttribute('data-bundle-key'), 'at frequency', state.frequency, plans);
            return;
          }

          var priceEl = bundleEl.querySelector('[data-vp-flow-price-text]');
          var compareEl = bundleEl.querySelector('[data-vp-flow-compare-text]');
          var perServeEl = bundleEl.querySelector('[data-vp-flow-per-serve-text]');
          var savingsEl = bundleEl.querySelector('[data-vp-flow-bundle-savings]');

          // Each plan's compareAt is already correctly scaled for its own
          // frequency (fixed bundles: variant compare-at × that
          // frequency's cart quantity; dynamic bundles: unit compare-at ×
          // that frequency's refill count) — just use it directly.
          var save = plan.compareAt > plan.price ? (plan.compareAt - plan.price) : 0;

          if (priceEl) priceEl.textContent = currencyFormat(plan.price);
          if (compareEl) {
            if (plan.compareAt > plan.price) {
              compareEl.textContent = currencyFormat(plan.compareAt);
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }
          if (perServeEl && plan.perServe > 0) perServeEl.textContent = currencyFormat(plan.perServe) + ' per serving';
          if (savingsEl) {
            if (save > 0) {
              savingsEl.textContent = 'Save ' + currencyFormat(save);
              savingsEl.hidden = false;
            } else {
              savingsEl.hidden = true;
            }
          }

          var bundleImage1m = bundleEl.querySelector('[data-vp-flow-bundle-image="1month"]');
          var bundleImage3m = bundleEl.querySelector('[data-vp-flow-bundle-image="3month"]');
          if (bundleImage1m && bundleImage3m) {
            bundleImage1m.hidden = state.frequency === '3month';
            bundleImage3m.hidden = state.frequency !== '3month';
          }

          var features1 = bundleEl.querySelector('[data-vp-flow-features="1month"]');
          var features3 = bundleEl.querySelector('[data-vp-flow-features="3month"]');
          if (features1 && features3) {
            features1.hidden = state.frequency === '3month';
            features3.hidden = state.frequency !== '3month';
          }
        } catch (err) {
          console.error('VP Flow: failed to update bundle prices for', bundleEl.getAttribute('data-bundle-key'), err);
        }
      });
    }

    function initFreqTabs() {
      var tabs = root.querySelectorAll('[data-vp-flow-freq-tab]');
      if (!tabs.length) return;

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          state.frequency = tab.getAttribute('data-vp-flow-freq-tab') === '3month' ? '3month' : '1month';
          // Toggles active state only — never writes translated text.
          applyFreqTabActiveState();
          updateBundlePricesForFrequency();
          // NOTE: no updateRefillCardPrices() call here anymore — step 2's
          // refill card prices are a static best-value figure now (see
          // getBestRefillUnitPrice), unaffected by which frequency is
          // active in step 3.
          var activeBundleEl = state.bundle ? root.querySelector('[data-bundle-key="' + state.bundle + '"]') : null;
          prefetchBundleSelection(activeBundleEl, state.frequency);
        });
      });
    }

    initColorPicker();
    initRefillTabs();
    initRefillPicker();
    initBundlePicker();
    initFreqTabs();
    initNav();
    showStep(1);
  }

  function initToggle() {
    // Start buffering the step-1 video on finger-down on the CTA, ahead of
    // the click that opens the overlay.
    document.addEventListener('pointerdown', function (event) {
      var toggler = event.target.closest('[data-vp-flow-toggle]') || event.target.closest('[href="#vp-flow-toggle"]');
      if (toggler) warmFlows();
    }, { passive: true });

    document.addEventListener('click', function (event) {
      var toggler = event.target.closest('[data-vp-flow-toggle]') || event.target.closest('[href="#vp-flow-toggle"]');
      if (!toggler) return;

      event.preventDefault();

      showFlowOverlay();
      // Opening the overlay always lands on step 1 (case colour) —
      // showStep(1) never fires again on re-entry since it's only called
      // once at init, so step 1's view has to be tracked here instead.
      trackStepView(1, 'case');
    });
  }

  function initAll() {
    document.querySelectorAll('[data-vp-flow]').forEach(function (root) {
      if (root.dataset.vpFlowInit === 'true') return;
      initFlow(root);
      root.dataset.vpFlowInit = 'true';
    });

    // No idle warm-up here: it downloaded a ~2.4 MB video on every visit
    // while the flow stays hidden. initToggle() still warms on pointerdown
    // over the CTA, just before the flow opens.
  }

  initToggle();

  trackTriplePixel('PebbleV2Landing', { step: 0, label: 'homepage', path: window.location.pathname });

  if (document.readyState === 'complete') {
    initAll();
  } else {
    window.addEventListener('load', initAll);
  }

  document.addEventListener('shopify:section:load', initAll);
})();